import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const benefits = [
  "10+ years of industry expertise",
  "24/7 dedicated support team",
  "Proven track record of success",
  "Customized solutions for your needs",
  "Transparent pricing with no hidden fees",
  "Cutting-edge technology stack",
];

const WhyChooseUs = () => {
  return (
    <section id="why-us" className="relative py-24 md:py-32 px-6 md:px-12" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-heading font-bold uppercase tracking-widest text-xs text-lime-400 mb-4 block" data-testid="why-us-label">
              Why Choose LucentisIQ
            </span>
            <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight text-white mb-6" data-testid="why-us-title">
              Your Success is Our Mission
            </h2>
            <p className="font-body text-base md:text-lg text-slate-400 leading-relaxed mb-8" data-testid="why-us-description">
              We don't just deliver services—we forge partnerships. With LucentisIQ, you gain a strategic ally committed to driving your vision forward with precision, innovation, and unwavering dedication.
            </p>

            <div className="space-y-4">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.1 }}
                  className="flex items-start gap-3"
                  data-testid={`benefit-item-${index}`}
                >
                  <CheckCircle2 className="w-6 h-6 text-lime-400 flex-shrink-0 mt-0.5" data-testid={`benefit-icon-${index}`} />
                  <span className="font-body text-base text-slate-300" data-testid={`benefit-text-${index}`}>
                    {benefit}
                  </span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden border border-white/10" data-testid="why-us-image-container">
              <img
                src="https://images.unsplash.com/photo-1764258560299-3366d32f9ac9?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Team collaboration"
                className="w-full h-auto"
                data-testid="why-us-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
